export default __webpack_public_path__ + "static/media/mask.92486cee.jpeg";